/**
 * units.js -- Shared numeric conversion helpers for device forms.
 *
 * The UI works in percentages (0-100) while the sysconfig stores fractions
 * (0-1). Converting between them with plain multiply/divide introduces
 * IEEE-754 artifacts (e.g. 0.07 * 100 === 7.000000000000001), so `fracToPct`
 * rounds the result to kill the binary tail while preserving real precision.
 */

export const num = (v) => (v === "" || v == null ? 0 : parseFloat(v));

// Percentage (0-100) -> fraction (0-1).
export const pctToFrac = (v) => (v === "" || v == null ? 0 : num(v) / 100);

// Fraction (0-1) -> percentage (0-100), rounded to 6 decimal places to avoid
// floating-point display noise on the percent <-> fraction round-trip.
export const fracToPct = (v) =>
  v === "" || v == null ? v : Math.round(num(v) * 1e8) / 1e6;
